import styled from 'styled-components';

export const FilterWrapper = styled.div`
  position: relative;
  width: fit-content;
`;

export const FilterTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 20px;
  border: 1px solid ${({theme}) => theme.colors.$gray};
  background: ${({theme}) => theme.colors.branding.boxesModals};
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 100;
  min-width: 220px;
  border-radius: 12px;
  background: ${({theme}) => theme.colors.branding.boxesModals};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  overflow: hidden;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
`;

export const TriggerContent = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const OptionItem = styled.button<{$active: boolean}>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 16px;
  border: none;
  background: ${({theme, $active}) =>
    $active ? theme.colors.branding.backgroundSecondary : 'transparent'};
  color: ${({theme}) => theme.colors.branding.fontPrimary};
  font-size: 16px;
  font-weight: ${({$active}) => ($active ? 600 : 400)};
  cursor: pointer;
  text-align: left;
  border-radius: 8px;

  &:hover {
    background: ${({theme}) => theme.colors.branding.backgroundSecondary};
  }

  svg {
    color: ${({theme}) => theme.colors.branding.fontSecondary};
  }
`;

export const CheckIconWrapper = styled.span`
  margin-left: auto;
  color: ${({theme}) => theme.colors.branding.primary};
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  max-height: 320px;
  overflow-y: auto;
`;
